<template>
  <main class="trial-result">
    <section class="result-card" aria-labelledby="result-title">
      <div class="result-icon" aria-hidden="true">{{ result ? '✓' : 'i' }}</div>
      <h1 id="result-title">{{ result ? '试用申请已受理' : '申请 DCMP 试用' }}</h1>
      <p class="result-message">{{ result ? result.message : '填写企业信息，即可提交 DCMP 试用申请。' }}</p>
      <template v-if="result">
        <div class="application-number">
          <span>申请编号</span>
          <strong>{{ result.applicationNo }}</strong>
          <small>请保留此编号，便于后续联系与查询</small>
        </div>
        <div class="next-steps">
          <h2>接下来，请留意企业邮箱</h2>
          <ol>
            <li><span class="step-number" aria-hidden="true">1</span><div><h3>运营审核</h3><p>我们将审核您的试用申请</p></div></li>
            <li><span class="step-number" aria-hidden="true">2</span><div><h3>邮件激活</h3><p>审核通过后，按邮件指引设置密码</p></div></li>
            <li><span class="step-number" aria-hidden="true">3</span><div><h3>开始试用</h3><p>首次激活后，即可试用 DCMP {{ trialDays }} 天</p></div></li>
          </ol>
          <p class="mail-tip">未找到邮件？请同时查看垃圾邮件文件夹。</p>
        </div>
      </template>
      <router-link v-if="!result" class="home-button" to="/trial/">填写试用申请</router-link>
      <router-link v-else class="home-button" to="/home">返回首页</router-link>
    </section>
  </main>
</template>
<script>
import { trialRequest } from '@/utils/trialApi';
import { resolveTrialDays } from '@/utils/trialPolicy.mjs';
export default {
  data() {
    let result = null;
    try { result = JSON.parse(sessionStorage.getItem('dcmp-trial-result')); } catch (_) { /* No personal data is stored. */ }
    return { result: result && result.accepted ? result : null, trialDays: resolveTrialDays(result && result.trialDays) };
  },
  async mounted() {
    try {
      const config = await trialRequest('/config');
      this.trialDays = resolveTrialDays(this.result && this.result.trialDays, config.defaultTrialDays);
    } catch (_) { /* The application snapshot or seven-day default remains readable. */ }
  },
};
</script>
<style scoped>
.trial-result {
  width: 100%;
  min-height: calc(100vh - 80px);
  display: flex;
  justify-content: center;
  align-items: flex-start;
  padding: 48px 24px 64px;
  background: #f2f7fc;
  color: #24394b;
  font-size: 20px;
  line-height: 1.7;
}
/* The portal's global body * rule otherwise resets nested text to 0.14rem. */
.result-card * { font-size: inherit; }
.result-card {
  font-size: inherit;
  width: 100%;
  max-width: 920px;
  min-width: 0;
  padding: 40px 48px;
  border: 1px solid #e5edf4;
  border-radius: 20px;
  background: #fff;
  box-shadow: 0 12px 40px rgba(36, 57, 75, 0.05);
  text-align: center;
}
.result-icon {
  width: 72px;
  height: 72px;
  margin: 0 auto 20px;
  border-radius: 50%;
  background: #e9f7f0;
  color: #128463;
  font-size: 44px;
  line-height: 72px;
  font-weight: 600;
}
.result-card h1 { margin: 0 0 12px; color: #183348; font-size: 36px; line-height: 1.35; font-weight: 600; }
.result-message { margin: 0; }
.application-number { display: grid; gap: 4px; margin: 28px 0; padding: 16px 20px; border-radius: 10px; background: #f2f7fc; }
.application-number span { color: #536779; font-size: 17px; }
.application-number strong { color: #183348; font-size: 22px; overflow-wrap: anywhere; letter-spacing: 0.5px; }
.application-number small { color: #536779; font-size: 16px; }
.next-steps { text-align: left; }
.next-steps h2 { margin: 0 0 20px; font-size: 22px; font-weight: 600; }
.next-steps ol { display: grid; grid-template-columns: repeat(3, minmax(0, 1fr)); gap: 22px; margin: 0; padding: 0; list-style: none; }
.next-steps li { display: flex; align-items: flex-start; gap: 10px; min-width: 0; }
.next-steps li > div { min-width: 0; flex-shrink: 1; }
.step-number { flex-shrink: 0; width: 30px; height: 30px; border-radius: 50%; background: #e9f7f0; color: #128463; font-size: 17px; font-weight: 600; line-height: 30px; text-align: center; }
.next-steps h3 { margin: 0 0 6px; font-size: 20px; line-height: 30px; font-weight: 600; }
.next-steps li p { margin: 0; color: #536779; font-size: 17px; line-height: 1.65; }
.mail-tip { margin: 24px 0 0; color: #536779; font-size: 17px; }
.home-button { display: inline-flex; align-items: center; justify-content: center; min-width: 208px; min-height: 52px; margin-top: 28px; padding: 10px 28px; border: 1px solid #005c85; border-radius: 8px; background: #005c85; color: #fff; font-size: 20px; font-weight: 600; text-decoration: none; transition: background 0.15s; }
.home-button:hover { background: #004c70; color: #fff; }
.home-button:focus-visible { outline: 3px solid #67afd1; outline-offset: 4px; }
@media (max-width: 640px) {
  .trial-result { min-height: calc(100vh - 40px); padding: 24px 16px 40px; font-size: 18px; }
  .result-card { padding: 28px 22px; border-radius: 16px; }
  .result-card h1 { font-size: 28px; }
  .result-icon { margin-bottom: 16px; }
  .application-number { margin: 24px 0; padding: 14px 12px; }
  .application-number strong { font-size: 19px; }
  .next-steps h2 { font-size: 20px; }
  .next-steps ol { grid-template-columns: 1fr; gap: 18px; }
  .home-button { width: 100%; }
}
</style>
